// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","content":"_3HttYC","imageWrapper":"_2p9a-k","fadeInFrames":"_1oQPpA"};